import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
// import { history } from 'kts-platform-frame/routes';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import { withRouter } from 'src/node_modules/kts-platform-frame/routes';
import SearchGroup from 'src/display/components/SearchGroup';
import ScreenList from 'src/display/components/ScreenList';
import { Form, Row, Col, Select, Input } from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@create()
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            setInputValHandler: undefined
        };
    }
    labelHandler = (key, val) => {
        let list = [];
        let value = '';
        switch (key) {
            case 'appCategoryId':
                value = this.modulesState.appCategoryList.filter(item => item.categoryId === val)[0].categoryName;
                list.push({ name: '应用分类', value, key });
                break;
            case 'isOpen':
                value = this.modulesState.isOpenList.filter(item => item.id === val)[0].name;
                list.push({ name: '应用类型', value, key });
                break;
            default:
                list.push({ name: '应用名称', value: val, key: 'appName' });
                break;
        }
        return list;
    }
    searchInputOnchangeSetScreent = (v) => {
        let list = this.modulesState.screenListData&&[...this.modulesState.screenListData]||[];
        let isTaget = true;
        let l = list.length;
        for (var i = 0; i < l; i++ ) {
            if (list[i].key === 'appName') {
                if (v) {
                    list[i].value = v;
                } else {
                    list.splice(i, 1);
                }
                isTaget = false;
                break;
            }
        }
        if (isTaget && v) {
            list.push({
                name: '应用名称',
                value: v, 
                key: 'appName'
            });
        }
        this.modulesState.screenListData = list;
        this.setModulesState();
    }
    searchFn = (v?:string) => {
        this.searchInputOnchangeSetScreent(v);
        this.modulesState.searchInfo.appName = v;
        // this.modulesState.pageNum = 1;
        this.setModulesState();
        ModulesAction.updateAppList();
    }
    searchFormSubmit = (inputVal) => {
        this.modulesState.searchInfo.appName = inputVal || '';
        this.setModulesState();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let list = [];
                Object.keys(values).map((key, index) => {
                    if (values[key] !== null  && values[key] !== '' && values[key] !== undefined) {
                        list = list.concat([...this.labelHandler(key, values[key])]);
                    }
                });
                this.modulesState.screenListData = list;
                this.modulesState.searchInfo = {...values};
                // this.modulesState.pageNum = 1;
                this.state.setInputValHandler && this.state.setInputValHandler(this.modulesState.searchInfo.appName);
                this.setModulesState();
                ModulesAction.updateAppList();
            }
        });
    }
    deleteHandler = (item?: any, index?: number) => {
        if (index || index === 0) {
            // ui展示
            let list = [...this.modulesState.screenListData];
            list.splice(index, 1);
            this.modulesState.screenListData = list;
            if(item.key === 'isOpen'){
                this.modulesState.searchInfo.isOpen = 'all';
            }
            this.modulesState.searchInfo[item.key] = null;
        } else {
            this.modulesState.screenListData = [];
            this.modulesState.searchInfo = {
                appName:'',
                appCategoryId:'',
                isOpen:'all'
            };
        }
       
        this.state.setInputValHandler && this.state.setInputValHandler(this.modulesState.searchInfo.appName);
        this.setModulesState();
        ModulesAction.updateAppList();
    }
    resetFieldsHandler = () => {
        this.props.form.setFieldsValue({
            appName:'',
            appCategoryId:'',
            isOpen:'all'
        });
        this.modulesState.searchInfo = {
            appName:'',
            appCategoryId:'',
            isOpen:'all'
        };
        this.setModulesState();
    }
    setInputValHandler = (cb) => {
        this.setState({
            setInputValHandler: cb
        });
    }
    render() {
        const { getFieldDecorator, resetFields } = this.props.form;
        const otherElement = (
            <div style={{ display: 'flex', alignItems: 'center', paddingTop: '20px' }}>
                <ScreenList
                    menuItem={this.modulesState.screenListData}
                    screenTextClassName={css.screenTextClassName}
                    deleteFn={this.deleteHandler}
                    trigger={['hover']}
                    isTooltip={true}
                    isShowAllDelete={true}
                    limit={999}
                />
            </div>
        );
        return (
            <div className={'headFilter'} style={{position: 'relative'}}>
                <SearchGroup
                    width={570}
                    resetFields={resetFields}
                    resetFieldsHandler={this.resetFieldsHandler}
                    searchFormSubmit={this.searchFormSubmit}
                    searchInputFn={this.searchFn}
                    clearSearch={this.searchFn}
                    placeholder='搜索应用'
                    hidelSearch={false}
                    otherElement={otherElement}
                    searchFormClassName={'searchFormClassName'}
                    searchInputClassName={'searchInputClassName'}
                    setInputVal={this.setInputValHandler}
                    autoComplete={true}
                >
                    <Form
                        className={'filterForm'}
                        colon={false}
                        labelAlign="left"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                    >
                        <Row type="flex" justify="start">
                            <Col span={24}>
                                <Form.Item label="应用名称">
                                    {getFieldDecorator('appName', {
                                        initialValue: this.modulesState.searchInfo.appName
                                    })(
                                        <Input placeholder='请输入应用名称' className={'singleInputPaddLeft'} />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        {/* <Row type="flex" justify="start">
                            <Col span={24}>
                                <Form.Item label="应用类型">
                                    {getFieldDecorator('isOpen', {
                                        initialValue: this.modulesState.searchInfo.isOpen
                                    })(
                                        <Select className={css.borderLeftRadius} onChange={(e => { })} style={{ width: '100' }}>
                                            {this.modulesState.isOpenList.map(item => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row> */}
                        <Row type="flex" justify="start">
                            <Col span={24}>
                                <Form.Item label="应用分类">
                                    {getFieldDecorator('appCategoryId', {
                                        initialValue: this.modulesState.searchInfo.appCategoryId
                                    })(
                                        <Select className={css.borderRightRadius} onChange={(e => { })} style={{ width: '100%' }}>
                                            <Select.Option value=''>全部</Select.Option>
                                            {
                                                this.modulesState.appCategoryList && this.modulesState.appCategoryList.map(({ categoryId, categoryName }) => {
                                                    return <Select.Option key={categoryId} value={categoryId}>{categoryName}</Select.Option>;
                                                })
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </SearchGroup>
                
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/apps/AppSearch/UI.AppBox/UI.Head.tsx